import { render, staticRenderFns } from "./TheAccountStatus.vue?vue&type=template&id=15f8a58b&scoped=true"
import script from "./TheAccountStatus.vue?vue&type=script&lang=js"
export * from "./TheAccountStatus.vue?vue&type=script&lang=js"
import style0 from "./TheAccountStatus.vue?vue&type=style&index=0&id=15f8a58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8a58b",
  null
  
)

export default component.exports